import { z } from 'zod';
import { requiredIntFromNumberInput, requiredReferenceIdSchema } from '@/shared/utils/formZod.schema.utils';

export const varaFormSchema = z
  .object({
    ordem: requiredIntFromNumberInput({
      requiredMessage: 'Informe a ordem',
      min: 0,
      minMessage: 'A ordem deve ser zero ou maior',
    }),
    nome: z.string().trim().min(1, 'Informe o nome da vara'),
    atuacao: requiredReferenceIdSchema,
    criminal: z.boolean().optional(),
    civel: z.boolean().optional(),
  })
  .passthrough();

export type VaraFormValues = z.infer<typeof varaFormSchema>;
